if (!customElements.get('sticky-atc-bar')) {
  customElements.define(
    'sticky-atc-bar',
    class StickyAtcBar extends HTMLElement {
      constructor() {
        super();
        this.sectionId = this.dataset.section;
        this.addButton = this.querySelector('[data-sticky-add]');
        this.addButtonText = this.querySelector('[data-sticky-add-text]');
        this.priceTarget = this.querySelector('[data-sticky-price]');
        this.realSubmitButton = document.getElementById(this.dataset.submitButtonId);
      }

      connectedCallback() {
        if (this.addButton && this.realSubmitButton) {
          this.addButton.addEventListener('click', () => {
            this.realSubmitButton.click();
          });
        }

        this.setupVisibility();

        if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
          this.variantUnsubscriber = subscribe(PUB_SUB_EVENTS.variantChange, (event) => {
            if (!event || !event.data || event.data.sectionId != this.sectionId) return;
            this.updateFromVariant(event.data.variant, event.data.html);
          });
        }
      }

      disconnectedCallback() {
        if (this.variantUnsubscriber) this.variantUnsubscriber();
        if (this.observer) this.observer.disconnect();
      }

      setupVisibility() {
        const anchor = this.realSubmitButton || document.getElementById(`MainProduct-${this.sectionId}`);
        if (!anchor || !('IntersectionObserver' in window)) {
          this.classList.add('sticky-atc-bar--visible');
          return;
        }

        this.observer = new IntersectionObserver(
          (entries) => {
            entries.forEach((entry) => {
              // Show the bar only when the real button has scrolled ABOVE the viewport.
              const scrolledPast = !entry.isIntersecting && entry.boundingClientRect.top < 0;
              this.classList.toggle('sticky-atc-bar--visible', scrolledPast);
            });
          },
          { rootMargin: '0px 0px 0px 0px', threshold: 0 }
        );
        this.observer.observe(anchor);
      }

      updateFromVariant(variant, html) {
        if (!variant) {
          this.setSoldOut();
          return;
        }

        // Availability + button label
        if (variant.available === false) {
          this.setSoldOut();
        } else {
          this.addButton.disabled = false;
          this.addButton.classList.remove('button--secondary');
          if (this.addButtonText) {
            this.addButtonText.textContent = this.addButtonText.dataset.addLabel || this.addButtonText.textContent;
          }
        }

        // Price — reuse the server-rendered price node for correct formatting
        if (html && this.priceTarget && this.dataset.priceId) {
          try {
            const parsed = new DOMParser().parseFromString(html, 'text/html');
            const priceNode = parsed.getElementById(this.dataset.priceId);
            if (priceNode) {
              const sale = priceNode.querySelector('.price-item--sale, .price__sale .price-item');
              const regular = priceNode.querySelector('.price-item--regular');
              const chosen = sale || regular;
              if (chosen) this.priceTarget.textContent = chosen.textContent.trim();
            }
          } catch (e) {
            /* leave existing price */
          }
        }

        // Thumbnail
        if (variant.featured_image && variant.featured_image.src) {
          const img = this.querySelector('.sticky-atc-bar__media img');
          const src = variant.featured_image.src;
          const sized = src + (src.indexOf('?') === -1 ? '?' : '&') + 'width=100';
          if (img) {
            img.src = sized;
          } else {
            const media = this.querySelector('.sticky-atc-bar__media');
            if (media) media.innerHTML = `<img src="${sized}" alt="" width="46" height="46" loading="lazy">`;
          }
        }
      }

      setSoldOut() {
        if (!this.addButton) return;
        this.addButton.disabled = true;
        this.addButton.classList.add('button--secondary');
        if (this.addButtonText) {
          this.addButtonText.textContent = this.addButtonText.dataset.soldOutLabel || this.addButtonText.textContent;
        }
      }
    }
  );
}
